<template>
	<div class="update-order-dialog">
		<el-dialog title="修改订单归属" :visible.sync="dialogVisible" width="540px" :before-close="handleClose" :close-on-click-modal="false">
			<div class="content">
				<Tip>
					<div class="alert-rule yx-color-text-primary ml-10 font-h4-regular" slot="content">
						<div class="fz-14">修改支付时间为当月的订单，按照员工当月的提成...</div>
						<el-button type="text" @click="showRuleDialog">查看修改订单规则</el-button>
					</div>
				</Tip>
				<template v-if="isAll">
					<div class="mt-24">
						<span class="yx-color-text-primary yx-pingfang-semibold">查询条件：</span>
						<span class="yx-color-text-regular yx-pingfang-semibold" v-if="!paramsTextArr.length">未设置查询条件，默认修改全部订单</span>
						<div v-else ref="content" class="overflow-hidden">
							<div
								v-for="item in paramsTextArr"
								:key="item.key"
								class="yx-pingfang-semibold mt-14 fz-13"
								style="display: inline-block; margin-right: 40px"
							>
								<template v-if="item.key === '异常订单'">
									<span class="yx-color-text-regular" v-if="item.value"
										><i class="el-icon-check yx-color-primary fz-16" style="font-weight: bold; margin-right: 2px"></i>{{ item.text }}</span
									>
								</template>
								<template v-else>
									<span class="yx-color-text-regular">{{ item.key }}</span>
									<span class="yx-color-text-primary ml-12">{{
										item.text | textFormat(item.key === '结算时间' || item.key === '付款时间' ? 99 : 9)
									}}</span>
									<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
									<el-tag v-else-if="item.use_status && item.use_status === '2'" class="ml-8" type="danger" size="mini">账号已停用</el-tag>
								</template>
							</div>
						</div>
						<el-button type="text" @click="open" v-if="showOpen">展开</el-button>
						<el-button type="text" @click="pickup" v-if="showPickUp">收起</el-button>
					</div>
					<el-divider></el-divider>
				</template>
				<div class="font-bold mt-16">
					<template v-if="isAll">
						查询订单总计：
						<template v-if="result.loading"> <i class="el-icon-loading yx-color-primary"></i> 数据统计中 </template>
						<template v-else-if="resultFail">
							<i class="el-icon-error yx-color-danger"></i> 统计失败，请点击<el-button type="text" @click="$emit('refresh')">重新统计</el-button>
						</template>
						<template v-else>
							订单量 <span class="yx-color-warning">{{ result.order_count }}</span
							>，订单金额 <span class="yx-color-warning">{{ orderPrice | formatPrice }}</span>
						</template>
					</template>
					<template v-else>
						修改订单总计：订单量 <span class="yx-color-warning">{{ count }}</span
						>，订单金额 <span class="yx-color-warning">{{ orderPrice | formatPrice }}</span>
					</template>
				</div>
				<el-form class="mt-24" :model="form" :rules="rules" ref="ruleForm" label-width="70px" hide-required-asterisk>
					<el-form-item label-width="0">
						<el-radio-group v-model="partnerType">
							<el-radio-button :label="1">达人商务</el-radio-button>
							<el-radio-button :label="2">招商运营</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<div v-show="isDrPartner">
						<el-form-item :label="drName" prop="user_id_dr">
							<dr-partner-select
								class="width100"
								v-model="form.user_id_dr"
								:placeholder="`请选择${drName}`"
								@change="getPartnerRate"
								:customData="customList"
							/>
						</el-form-item>
						<div class="box" v-show="isShowScale">
							<div class="flex flex-align-center">
								<div>达人分成比：{{ scaleText(form.scale) }}</div>
								<div class="ml-20">团长分成比：{{ scaleText(form.partner_scale) }}</div>
							</div>
							<div class="update-btn" @click="showScaleDialog">
								<i class="el-icon-edit-outline"></i>
								<div class="ml-4">修改</div>
							</div>
						</div>
					</div>
					<div v-show="isShopPartner">
						<el-form-item :label="zsName" prop="user_id_zs">
							<zs-partner-select
								class="width100"
								v-model="form.user_id_zs"
								:placeholder="`请选择${zsName}`"
								:show-icon="false"
								:customData="customList"
								@change="getZsPartnerRate"
							/>
						</el-form-item>
						<div class="box" v-show="isZsShowScale">
							<div>分成比：{{ scaleText(form.bd_partner_scale) }}</div>
							<div class="update-btn" @click="showZsScaleDialog">
								<i class="el-icon-edit-outline"></i>
								<div class="ml-4">修改</div>
							</div>
						</div>
					</div>
				</el-form>
				<div v-if="!isAll" class="align-right" :class="{ 'mt-16': isShowScale || isZsShowScale }"
					>如需修改所有筛选结果订单，建议使用<span class="pointer primary-color" @click="setUpdateType">修改查询订单归属</span></div
				>
			</div>
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="showHintDialog" :disabled="confirmBtnDisabled" :loading="loading">确 认</el-button>
			</span>
		</el-dialog>
		<hint-dialog ref="hintDialog" @submit="submit" :platformId="platformId" />
		<rule-dialog ref="ruleDialog" />
		<scale-dialog ref="scaleDialog" @setScale="setScale" />
		<zs-scale-dialog ref="zsScaleDialog" @setScale="setZsScale" />
	</div>
</template>

<script>
import drPartnerSelect from '@/components/drPartnerSelect';
import zsPartnerSelect from '@/components/zsPartnerSelect';
import hintDialog from './components/hintDialog';
import ruleDialog from './components/ruleDialog';
import scaleDialog from './components/scaleDialog';
import zsScaleDialog from './components/zsScaleDialog';
import { getPartnerRate, updateOrderBatchBelong, updateOrderSearchBelong, batchBelongBySelectSp, batchbelongBySearchSp } from '@/api/shopManage';
import { drRoleType, zsRoleType } from '@/utils/dataMap';
import debounce from 'lodash/debounce';
import dataMap from '../../../../../../utils/dataMap';
export default {
	name: 'affiliationDialog',
	components: {
		drPartnerSelect,
		zsPartnerSelect,
		hintDialog,
		ruleDialog,
		scaleDialog,
		zsScaleDialog,
	},
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
		result: {
			type: Object,
			default: () => ({}),
		},
		searchParams: {
			type: Object,
			default: _ => ({}),
		},
		paramsTextArr: {
			type: Array,
			default: () => [],
		},
	},
	created() {
		this.$Bus.$on('showAffiliationDialog', selectionShopArr => {
			this.show(selectionShopArr);
		});
	},
	data() {
		const validator = (msg, type) => (rule, value, callback) =>
			this.form.is_belong && this.partnerType === type && !value ? callback(new Error(msg)) : callback();
		const scaleValidator = msg => (rule, value, callback) => {
			if (!this.form.is_belong || this.isShopPartner) return callback();
			if (value == '') return callback(new Error(`请输入${msg}`));
			if (+value < 0 || +value > 100) return callback(new Error(`${msg}范围在0-100之间`));
			callback();
		};
		return {
			dialogVisible: false,
			selectionShopArr: [],
			partnerType: 1,
			form: {
				user_id_dr: '',
				scale: '',
				partner_scale: '',
				is_belong: 1,
				user_id_zs: '',
				bd_partner_scale: '',
			},
			rules: {
				user_id_dr: { validator: validator(`请选择${drRoleType.name}`, 1), trigger: 'change', required: true },
				scale: { validator: scaleValidator('达人分成比'), trigger: 'change', required: true },
				partner_scale: { validator: scaleValidator('团长分成比'), trigger: 'change', required: true },
				user_id_zs: { validator: validator(`请选择${zsRoleType.name}`, 2), trigger: 'change', required: true },
			},
			customList: [{ userId: '0', name: '设为无归属' }],
			contentHeight: 0,
			showOpen: false,
			showPickUp: false,
			loading: false,
			// 提成比是否获取成功
			hasRateReturned: true,
		};
	},
	computed: {
		isAll() {
			return !this.selectionShopArr.length;
		},
		count() {
			const {
				isAll,
				selectionShopArr,
				result: { order_count = 0 },
			} = this;
			return isAll ? order_count : selectionShopArr.length;
		},
		orderPrice() {
			const {
				isAll,
				selectionShopArr,
				result: { total_pay_amount = 0 },
			} = this;
			const total = selectionShopArr.reduce((a, b) => +b.total_pay_amount + a, 0);
			return isAll ? total_pay_amount : total.toFixed(2);
		},
		drName() {
			return drRoleType.name;
		},
		zsName() {
			return zsRoleType.name;
		},
		isShowScale() {
			const { user_id_dr } = this.form;
			return user_id_dr && user_id_dr != 0;
		},
		isZsShowScale() {
			const { user_id_zs } = this.form;
			return user_id_zs && user_id_zs != 0;
		},
		scaleText() {
			return scale => {
				if (scale === '--') return '未设置';
				return `${scale}%`;
			};
		},
		resultFail() {
			return this.result.status === 'error';
		},
		// 查询结果修改订单归属时
		// 接口加载中或接口不成功或订单数量为0
		// 确定按钮禁用
		confirmBtnDisabled() {
			return (this.isAll && (this.result.loading || this.resultFail || !+this.result.order_count)) || (!this.isAll && !this.hasRateReturned);
		},
		searchParamsText() {
			return {};
		},
		isDrPartner() {
			return this.partnerType === 1;
		},
		isShopPartner() {
			return this.partnerType === 2;
		},
	},
	watch: {
		paramsTextArr(val) {
			this.isAll &&
				val?.length &&
				this.$nextTick(() => {
					if (this.$refs['content']) {
						const contentHeight = this.$refs?.content?.clientHeight;
						this.$refs.content.style.height = Number(contentHeight) > 66 ? '66px' : 'auto';
						this.showOpen = Number(contentHeight) > 66;
					}
				});
		},
	},
	methods: {
		show(selectionShopArr = []) {
			this.selectionShopArr = selectionShopArr;
			this.dialogVisible = true;
		},
		handleClose() {
			this.selectionShopArr = [];
			this.partnerType = 1;
			this.form = {
				user_id_dr: '',
				scale: '',
				partner_scale: '',
				is_belong: 1,
				user_id_zs: '',
				bd_partner_scale: '',
			};
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
			this.showOpen = false;
			this.showPickUp = false;
		},
		async getPartnerRate(user_id) {
			this.hasRateReturned = false;
			if (!user_id) {
				this.form.scale = this.form.partner_scale = '';
				this.hasRateReturned = true;
				return;
			}
			this.setIsBelong(user_id);
			if (user_id === '0') {
				this.hasRateReturned = true;
				return;
			}
			try {
				const {
					code,
					data: { rate_value, institution_rate_value },
				} = await getPartnerRate({ userId: user_id, roleId: 3 });
				if (code !== 0) return;
				this.form.scale = rate_value;
				this.form.partner_scale = institution_rate_value;
				this.hasRateReturned = true;
			} catch (error) {
				this.hasRateReturned = false;
			}
		},
		async getZsPartnerRate(user_id) {
			if (!user_id) return (this.form.bd_partner_scale = '');
			this.setIsBelong(user_id);
			if (user_id === '0') {
				return;
			}
			const {
				code,
				data: { rate_value },
			} = await getPartnerRate({ userId: user_id, roleId: 2 });
			if (code !== 0) return;
			this.form.bd_partner_scale = rate_value;
		},
		showHintDialog: debounce(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				this.count > 1000 ? this.$refs.hintDialog.show() : this.submit();
			});
		}, 500),
		async submit() {
			this.loading = true;
			try {
				let {
					searchParams: search_params,
					form: { user_id_dr, scale, partner_scale, is_belong, user_id_zs, bd_partner_scale },
					selectionShopArr,
					partnerType,
					isAll,
					platformId: platform_id,
					result,
				} = this;
				search_params = { ...search_params, order_count: result.order_count };
				let belong_params = { is_belong };
				if (is_belong) {
					belong_params = this.isDrPartner
						? { ...belong_params, scale, partner_scale, userId: user_id_dr }
						: { ...belong_params, bd_partner_scale, userId: user_id_zs };
				}
				let params = isAll
					? { search_params, belong_params, type: partnerType }
					: {
							platform_id,
							order_ids: selectionShopArr.map(item => item.order_id),
							belong_params,
							type: partnerType,
							ids: selectionShopArr.map(item => item.id),
					  };
				if (this.$isSp()) {
					let { is_belong, partner_scale, scale, userId, bd_partner_scale } = belong_params;
					let belongParams = this.isDrPartner
						? {
								isBelong: is_belong,
								partnerScale: partner_scale,
								scale: scale,
								userId: userId,
						  }
						: {
								isBelong: is_belong,
								scale: bd_partner_scale,
								userId,
						  };
					params = isAll
						? {
								...search_params,
								belongParams,
								type: partnerType,
						  }
						: {
								orderIds: selectionShopArr.map(item => item.order_id),
								belongParams,
								type: partnerType,
						  };
				}
				const apiMap = {
					[dataMap.PLATFORM_DY.value]: isAll ? updateOrderSearchBelong : updateOrderBatchBelong,
					[dataMap.PLATFORM_KS.value]: isAll ? updateOrderSearchBelong : updateOrderBatchBelong,
					[dataMap.PLATFORM_SP.value]: isAll ? batchbelongBySearchSp : batchBelongBySelectSp,
				};

				const { code } = await apiMap[platform_id](params);
				this.loading = false;
				if (code !== 0) return;
				this.$message.success('修改订单归属成功');
				this.handleClose();
				this.$emit('refresh');
			} catch (error) {
				this.loading = false;
			}
		},
		showRuleDialog() {
			this.$refs.ruleDialog.show();
		},
		setIsBelong(value) {
			this.form.is_belong = value === '0' ? 0 : 1;
		},
		showScaleDialog() {
			const { scale, partner_scale } = this.form;
			this.$refs.scaleDialog.show({ scale, partner_scale });
		},
		setScale({ scale, partner_scale }) {
			this.form.scale = scale;
			this.form.partner_scale = partner_scale;
		},
		setUpdateType() {
			this.selectionShopArr = [];
			this.$emit('refresh');
		},
		showZsScaleDialog() {
			this.$refs.zsScaleDialog.show(this.form.bd_partner_scale);
		},
		setZsScale({ bd_partner_scale }) {
			this.form.bd_partner_scale = bd_partner_scale;
		},
		isDialogShow() {
			return this.dialogVisible;
		},
		open() {
			this.$refs.content.style.height = 'auto';
			this.showOpen = false;
			this.showPickUp = true;
		},
		pickup() {
			this.$refs.content.style.height = '66px';
			this.showOpen = true;
			this.showPickUp = false;
		},
	},
};
</script>

<style lang="less" scoped>
.update-order-dialog {
	.content {
		padding: 8px;
		color: #333;
		max-height: 562px;
		overflow-y: auto;
		.box {
			background-color: #f8f8f8;
			border-radius: 4px;
			padding: 16px 12px;
			margin-left: 70px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.update-btn {
				display: flex;
				align-items: center;
				line-height: 1;
				cursor: pointer;
				&:hover {
					color: @color-primary;
				}
			}
		}
		.alert-rule {
			display: flex;
			align-items: center;
			::v-deep .el-button--small {
				font-size: 13px;
				margin-left: 2px;
				height: auto;
				line-height: 1;
			}
		}
	}
}
.item {
	& + & {
		margin-left: 40px;
	}
}
/deep/ .el-divider {
	background-color: #eee;
}
/deep/.el-divider--horizontal {
	margin: 14px 0;
}
</style>
